module.exports = __webpack_public_path__ + "static/media/tryit_atom_orbit.8b1b6fef.svg";